import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  createPaymentApi,
  previewPaymentByIdApi,
  updatePaymentByIdApi,
} from '@src/api/payment';
import { UpdatePaymentItem } from '@src/types/payment';

export const createPaymentThunk = createAsyncThunk(
  'project/createPayment',
  async (
    {
      projectId,
      promotionId,
      companyCouponId,
    }: { projectId: string; promotionId?: string; companyCouponId?: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await createPaymentApi({
        projectId,
        promotionId,
        companyCouponId,
      });

      return response.result;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const previewPaymentThunk = createAsyncThunk(
  'project/previewPayment',
  async (
    {
      paymentId,
      paymentItems,
    }: { paymentId: string; paymentItems: UpdatePaymentItem[] },
    { rejectWithValue }
  ) => {
    try {
      const response = await previewPaymentByIdApi({ paymentId, paymentItems });

      return response.result;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const updatePaymentThunk = createAsyncThunk(
  'project/updatePayment',
  async (
    {
      paymentId,
      paymentItems,
    }: {
      paymentId: string;
      paymentItems: UpdatePaymentItem[];
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await updatePaymentByIdApi({ paymentId, paymentItems });

      return response.result;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);
